module.exports = __webpack_public_path__ + "static/media/17_yhteistyo-ja-kumppanuus_en_US.42ce68c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/agendaIcons/17_yhteistyo-ja-kumppanuus_en_US.svg
// module id = ./src/images/agendaIcons/17_yhteistyo-ja-kumppanuus_en_US.svg
// module chunks = 1